import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './button-group.css';

const ButtonGroup = ({ children, isFullWidth, isStacked, isWrapped, isResponsive, dataId }) => {
    const buttonGroupClass = cx(styles.component, {
        [styles.isFullWidth]: isFullWidth,
        [styles.isResponsive]: isResponsive,
        [styles.isStacked]: isStacked,
        [styles.isWrapped]: isWrapped,
    });
    return (
        <div className={buttonGroupClass} role="group" data-qa="button-group" data-id={dataId}>
            {React.Children.toArray(children)
                .filter((c) => c)
                .map((child) =>
                    React.cloneElement(child, {
                        isWide: isFullWidth,
                        isResponsive,
                    }),
                )}
        </div>
    );
};

ButtonGroup.propTypes = {
    children: PropTypes.node.isRequired,
    isFullWidth: PropTypes.bool,
    isResponsive: PropTypes.bool,
    isWrapped: PropTypes.bool,
    isStacked: PropTypes.bool,
    dataId: PropTypes.string,
};

ButtonGroup.defaultProps = {
    isFullWidth: false,
    isResponsive: false,
    isWrapped: false,
    isStacked: false,
    dataId: undefined,
};

export default ButtonGroup;
